import { memo } from 'react';

import { useSensitiveDataWarningLogic } from './sensitive-data-warning.hook';
import { WARNING_STRINGS } from './utils/sensitive-data-warning.constants';
import type { TSensitiveDataWarningConfig } from './sensitive-data-warning.types';

import * as S from './sensitive-data-warning.styles';

const SensitiveDataWarning = memo(({ sensitiveDataWarning, toggleSensitiveDataWarning }: TSensitiveDataWarningConfig) => {
	const { isVisible, handleContinue, handleCancel } = useSensitiveDataWarningLogic({ sensitiveDataWarning, toggleSensitiveDataWarning });

	if (!isVisible) return null;

	return (
		<S.SensitiveDataWarning data-testid="sensitive-data-warning" data-qa="sensitive-data-warning">
			<S.Title>{WARNING_STRINGS.TITLE}</S.Title>
			<S.Text>
				{WARNING_STRINGS.TEXT}
			</S.Text>
			<S.ButtonsWrapper>
				<S.ContinueBtn type="button" data-qa="sensitive-data-continue-button" onClick={handleContinue}>
					{WARNING_STRINGS.CONTINUE_BUTTON}
				</S.ContinueBtn>
				<S.CancelBtn type="button" data-qa="sensitive-data-cancel-button" onClick={handleCancel}>
					{WARNING_STRINGS.CANCEL_BUTTON}
				</S.CancelBtn>
			</S.ButtonsWrapper>
		</S.SensitiveDataWarning>
	);
});

SensitiveDataWarning.displayName = 'SensitiveDataWarning';
export { SensitiveDataWarning };
